"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAvailableWithdrawalBalance = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var useAvailableWithdrawalBalance = function () {
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.WITHDRAWAL_BALANCE,
        revalidateOnMount: true,
    }), mutate = _a.mutate, data = _a.data, error = _a.error, isLoading = _a.isLoading, isValidating = _a.isValidating;
    return (0, react_1.useMemo)(function () { return ({
        getBalance: mutate,
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        error: error,
        isValidating: isValidating,
    }); }, [isValidating, data, isLoading, mutate, error]);
};
exports.useAvailableWithdrawalBalance = useAvailableWithdrawalBalance;
